import React from "react";
import PropTypes from "prop-types";

const Slide = ({ slide, onClick, restUrl }) => {
    return (
        <a
            key={slide.id}
            href={slide.url}
            onClick={()=>{
                onClick(slide);
            }}
            title={slide.img_title}
            className={"banner-slide"}
            target={"_blank"}
        >
            <img
                src={`${restUrl}/pub/media/aw_rbslider/slides/${slide.img_file}`}
                alt={slide.img_alt}
            />
        </a>
    );
};

export default React.memo(Slide);

Slide.propTypes = {
    slide: PropTypes.object,
    onClick: PropTypes.func,
    restUrl: PropTypes.string,
    isVisible: PropTypes.bool
};